//REGISTER
export const POST_JWT_REGISTER = "/api/auth/signup";


//LOGIN
export const POST_JWT_LOGIN = "/api/auth/signin";
export const GET_AUTH_ME = "/api/auth/me";
// Authenticated change-password for a logged-in user (KAN-92).
export const POST_AUTH_CHANGE_PASSWORD = "/api/auth/change-password";
export const PUT_AUTH_ME_PREFERENCES = "/api/auth/me/preferences";
// SMS multi-factor. /verify and /resend are the public step-2 endpoints used by
// the login screen; the rest are self-service enrolment for a signed-in user.
export const POST_AUTH_MFA_VERIFY = "/api/auth/mfa/verify";
export const POST_AUTH_MFA_RESEND = "/api/auth/mfa/resend";
export const GET_AUTH_MFA_STATUS = "/api/auth/mfa/status";
export const POST_AUTH_MFA_SETUP_START = "/api/auth/mfa/setup/start";
export const POST_AUTH_MFA_SETUP_CONFIRM = "/api/auth/mfa/setup/confirm";
export const POST_AUTH_MFA_DISABLE = "/api/auth/mfa/disable";

//LOGIN
export const POST_GET_USER_INFO = "/api/user/get";

//SUPER-ADMIN CLIENT SWITCHER
export const GET_ADMIN_AGENCIES = "/api/admin/agencies";
export const POST_ADMIN_IMPERSONATE = "/api/admin/impersonate";


//Media
export const POST_MEDIA_CREATE = "/api/media/create";
export const GET_HEADING_IMAGES = "/api/media/get_heading_images";
export const GET_IMAGE_BY_ID = "/api/media/fileById";
export const DELETE_MEDIA = "/api/media/delete";
export const GET_PRESIGNED_URL = "/api/media/generate_presigned_url";
export const WATERMARK_MEDIA = "/api/media/watermark";
export const GET_MEDIA_PROXY = "/api/media/proxy";


//Client Review
export const GET_ALL_REVIEWS = "/api/client_review/get_All";
export const GET_ONE_REVIEW_BY_ID = "/api/client_review/getOneClientReview";
export const POST_CREAT_REVIEW = "/api/client_review/create";
export const UPDATE_CLIENT_REVIEW = "/api/client_review/update";
export const DELETE_REVIEW = "/api/client_review/delete";

//Domain.com.au
export const UPLOAD_LISTINGS_DOMAIN = "/api/domain/upload_listing";
export const PREVIEW_LISTING_JSON_DOMAIN = "/api/domain/preview_listing_json";
export const GET_DOMAIN_PROCESSING_REPORT = "/api/domain/report";

//REA
export const UPLOAD_LISTINGS_REA = "/api/rea/upload_listing_xml";
// REAXML export — builds the selected listings into a downloadable REAXML
// document. Read-only: no FTP, no portal rows, no sync dates. Owner-only,
// enforced server-side.
export const EXPORT_LISTINGS_REAXML = "/api/rea/export_listings_xml";
// Live listing counts per property type — drives the per-type export buttons.
export const EXPORT_LISTING_COUNTS = "/api/rea/export_listing_counts";
export const GET_ALL_REA_PORTALS = "/api/rea/get_All";
export const GET_REA_UPLOAD_REPORT = "/api/rea/get_upload_report";

// Listing portal

export const GET_ALL_LISTING_PORTALS = "/api/listing_portal/get_All";
export const GET_ACTIVATED_PORTALS = "/api/listing_portal/activated";
export const GET_ONE_PORTAL_BY_ID = "/api/listing_portal/getOneListingPortal";
export const POST_CREAT_PORTAL = "/api/listing_portal/create";
export const UPDATE_CLIENT_PORTAL = "/api/listing_portal/update";
export const DELETE_PORTAL = "/api/listing_portal/delete";

// REA feed processing status (FtpServer REAFeedProcessor pipeline) — the CRM
// Listing → Portal tab's "view progress" for the RealSoftware Office Website,
// keyed by CRM listingId, not the push-to-REA listing_portal rows above.
export const GET_REA_FEED_STATUS_BY_LISTING = "/api/rea-feed/status/by-listing";

// Listings(new)

export const GET_ALL_LISTINGERS = "/api/listinger/get_All";
export const FIND_LISTINGERS_BY_ADDRESS = "/api/listinger/find_by_address";
export const GET_ACTIVE__SOLD_LEASED_LISTINGERS = "/api/listinger/get_all_active_sold_leased";


export const GET_ONE_LISTINGER_BY_ID = "/api/listinger/getOneListinger";
export const POST_CREAT_LISTINGER = "/api/listinger/create";
export const UPDATE_CLIENT_LISTINGER = "/api/listinger/update";
export const DELETE_LISTINGER = "/api/listinger/delete";

// Appraisals (v2)
export const APPRAISAL_BASE = "/api/appraisal";
export const GET_ALL_APPRAISALS = "/api/appraisal/get_All";
export const GET_ONE_APPRAISAL_BY_ID = "/api/appraisal/getOne";
export const POST_CREATE_APPRAISAL = "/api/appraisal/create";
export const UPDATE_APPRAISAL = "/api/appraisal/update";
export const DELETE_APPRAISAL = "/api/appraisal/delete";
export const FIND_APPRAISALS_BY_ADDRESS = "/api/appraisal/find_by_address";
export const GET_APPRAISALS_BY_CONTACT = "/api/appraisal/by_contact";

export const UPLOAD_LISTING_IMAGE = "/api/listinger/uploadImage";
export const UPLOAD_LISTING_MEDIA = "/api/listinger/uploadMedia";
export const GET_ADDRESS_BY_PLACE_ID = "/api/listinger/getAddressByPlaceId";
export const CREATE_LISTING_PDF = "/api/listinger/createPdf";
export const CREATE_CUSTOM_PDF = "/api/listinger/websiteBrochure"
export const CREATE_STOCKLIST_PDF = "/api/listinger/createPdfStocklist";
export const GET_BROCHURE_MENU = "/api/listinger/brochureMenu";
export const FETCH_LISTINGS_WITH_FILTERS = "/api/listings/fetchWithFilters";
export const GET_ALL_UNIQUE_PROPERTY_TAGS = "/api/listinger/get_all_unique_property_tags";





// Listing Agent

export const GET_ALL_LISTINGAGENTS = "/api/listing_agent/get_All";
export const GET_ONE_LISTINGAGENT_BY_ID = "/api/listing_agent/getOneListinger";
export const POST_CREAT_LISTINGAGENT = "/api/listing_agent/create";
export const UPDATE_LISTINGAGENT = "/api/listing_agent/update";
export const LISTING_AGENT_API_URL = "/api/listing-agents";

export const DELETE_LISTINGAGENT = "/api/listing_agent/delete";


export const CONTACT_API_URL = "/api/contact";
export const CONTACT_BATCH_API_URL = "/api/contacts/batch";
export const PREFERENCE_API_URL = "/api/preference";

export const TASK_API_URL = "/api/tasks";
export const BLOG_API_URL = "/api/blogs";


// Marketing
export const CREATE_MARKETING_CAMPAIGN = "/api/campaign/create";
export const GET_ALL_MARKETING_CAMPAIGNS = "/api/campaign/all";
export const GET_CAMPAIGN_TEMPLATES = "/api/campaign-templates";
export const GET_ONE_MARKETING_CAMPAIGN_BY_ID = "/api/campaign/get";
export const UPDATE_MARKETING_CAMPAIGN = "/api/campaign/update";
export const DELETE_MARKETING_CAMPAIGN = "/api/campaign/delete";
export const ACTIVATE_MARKETING_CAMPAIGN = "/api/campaign/activate";
// Per-listing marketing contact segments (Trello #435)
export const LISTING_MARKETING_API_URL = "/api/listing-marketing";
export const GET_CONTACT_TAGS = "/api/contact/get_tags";
export const GET_EMAIL_PREVIEW = "/api/campaign/previewemail";
export const GET_CAMPAIGN_OPENS = "/api/campaign";
export const GET_CAMPAIGN_CLICKS = "/api/campaign";
export const GET_CAMPAIGN_REPLIES = "/api/campaign";

// Agency-wide reply Inbox (captured inbound email + read-tracking)
export const INBOX_REPLIES = "/api/inbox/replies";
export const INBOX_UNREAD_COUNT = "/api/inbox/unread-count";
export const SUPPORT_TICKETS = "/api/support/tickets";
export const SUPPORT_UPLOADS = "/api/support/uploads";


// Branding URLs
export const CREATE_BRANDING = '/api/branding/create';
export const GET_BRANDING_BY_CLIENT_ID = '/api/branding/getByClientId';
export const GET_CONTACT_BY_CLIENT_ID = '/api/branding/getContactByClientId';

export const UPDATE_BRANDING = '/api/branding/update';

// Hero / heading media — agency-owned (clientId-scoped), stored on branding.HeroImages.
// PUT /api/branding/heroImages/:clientId replaces the full list (add / remove / reorder).
export const SET_HERO_IMAGES = '/api/branding/heroImages';

// Social URLs
export const UPDATE_SOCIAL_URLS = '/api/branding/updateSocialUrls'; // Adjust the endpoint as needed
export const UPDATE_CONTACT_INFO = '/api/contact/update'; // Adjust according to your actual endpoint

// Automations — per-agency CRM automation config (toggles + custom copy).
export const GET_AUTOMATION_SETTINGS = '/api/automations';
export const UPDATE_AUTOMATION_SETTINGS = '/api/automations';

// Vendor report — email the shareable report link to the vendor.
export const SEND_VENDOR_REPORT = '/api/vendor-report/send';

// Offer form — email the shareable offer-form link to a contact.
export const SEND_OFFER_FORM_LINK = '/api/offer-form/send';

// Advertising / VPA (§24) — per-agency catalog, per-listing plan, report send.
export const ADVERTISING_CATALOG = '/api/advertising/catalog';
export const ADVERTISING_LISTING = '/api/advertising/listing';
export const SEND_ADVERTISING_REPORT = '/api/advertising-report/send';
export const ADVERTISING_INVOICE_SETTINGS = '/api/advertising/invoice-settings';

// Listing documents (§8/§33) — per-listing document store (signed agreements etc.).
export const LISTING_DOCUMENTS = '/api/listing-documents';

// Signed public share tokens (KAN-115) — backend mints the HMAC token; the
// browser must never sign it (would leak the secret). Authed; clientId comes
// from the caller's JWT, listingId from the path.
export const SHARE_PUBLIC_TOKEN = '/api/share/public-token';
export const SHARE_APPRAISAL_PUBLIC_TOKEN = '/api/share/appraisal-public-token';
export const SHARE_PROPERTY_URL = '/api/share/property-url';

// AI assistant (Claude).
export const AI_PROPERTY_DESCRIPTION = '/api/ai/property-description';
export const AI_BUYER_FEEDBACK = '/api/ai/buyer-feedback';
export const AI_DRAFT_REPLY = '/api/ai/draft-reply';
export const AI_EMAIL_CAMPAIGN = '/api/ai/email-campaign';
export const AI_SUPPORT_CHAT = '/api/ai/support-chat';

// Tag management (§20) — agency-wide rename / delete with propagation.
export const CONTACT_RENAME_TAG_API_URL = "/api/contact/rename_tag";
export const CONTACT_DELETE_TAG_API_URL = "/api/contact/delete_tag";

// Duplicate contacts (Admin → Permissions) — owner-only find / merge / hide.
export const CONTACT_DUPLICATES = "/api/contact-duplicates";
export const CONTACT_DUPLICATES_PREVIEW = "/api/contact-duplicates/preview";
export const CONTACT_DUPLICATES_MERGE = "/api/contact-duplicates/merge";
export const CONTACT_DUPLICATES_DISMISS = "/api/contact-duplicates/dismiss";

// Social media connections (per-agency tokens for auto-posting).
export const SOCIAL_CONNECTIONS = '/api/social-connections';

// Trust accounting.
export const TRUST_ACCOUNT = '/api/trust/account';
export const TRUST_DEPOSIT = '/api/trust/deposit';
export const TRUST_LEDGER = '/api/trust/ledger';
export const TRUST_SOLICITOR_LETTER = '/api/trust/solicitor-letter';
export const TRUST_SETTLEMENT = '/api/trust/settlement';
export const TRUST_DISBURSEMENT = '/api/trust/disbursement';
export const TRUST_REVERSE = '/api/trust/reverse';
export const TRUST_RECONCILIATION = '/api/trust/reconciliation';
export const TRUST_AUDIT_EXPORT = '/api/trust/audit-export';
export const TRUST_DASHBOARD = '/api/trust/dashboard';
export const TRUST_LEDGERS = '/api/trust/ledgers';
export const TRUST_LEDGER_DETAIL = '/api/trust/ledger-detail';
export const TRUST_RECEIPTS = '/api/trust/receipts';
export const TRUST_PAYMENTS = '/api/trust/payments';
export const TRUST_MATCH = '/api/trust/reconciliation/match';
export const TRUST_ABA = '/api/trust/aba';
export const TRUST_REPORT = '/api/trust/report';
// Contracts (sale lifecycle).
export const CONTRACTS_LIST = '/api/contracts/list';
export const CONTRACTS_DETAIL = '/api/contracts/detail';
export const CONTRACTS_BY_LISTING = '/api/contracts/by-listing';
export const CONTRACTS_CREATE = '/api/contracts/create';
export const CONTRACTS_FROM_LISTING = '/api/contracts/from-listing';
export const CONTRACTS_UPDATE = '/api/contracts/update';
export const CONTRACTS_CANCEL = '/api/contracts/cancel';
export const CONTRACTS_SALES_ADVICE = '/api/contracts/sales-advice';
export const CONTRACTS_SETTLE = '/api/contracts/settle';
export const CONTRACTS_SETTINGS = '/api/contracts/settings';

// Leased (lease-deal lifecycle — pipeline view over PM tenancies).
export const LEASED_LIST = '/api/leased/list';
export const LEASED_DETAIL = '/api/leased/detail';
export const LEASED_MILESTONE = '/api/leased/milestone';

// Lease agreements (internal pre-tenancy lease deal on the listing).
export const LEASE_AGREEMENTS_LIST = '/api/lease-agreements/list';
export const LEASE_AGREEMENTS_DETAIL = '/api/lease-agreements/detail';
export const LEASE_AGREEMENTS_BY_LISTING = '/api/lease-agreements/by-listing';
export const LEASE_AGREEMENTS_CREATE = '/api/lease-agreements/create';
export const LEASE_AGREEMENTS_FROM_LISTING = '/api/lease-agreements/from-listing';
export const LEASE_AGREEMENTS_UPDATE = '/api/lease-agreements/update';
export const LEASE_AGREEMENTS_CANCEL = '/api/lease-agreements/cancel';
export const LEASE_AGREEMENTS_ACTIVATE = '/api/lease-agreements/activate';

// Property management / rental trust accounting.
export const PM_ACCOUNT = '/api/pm/account';
export const PM_SETTINGS = '/api/pm/settings';
export const PM_MANAGEMENTS = '/api/pm/managements';
export const PM_MANAGEMENT = '/api/pm/management';
export const PM_FROM_LISTING = '/api/pm/from-listing';
export const PM_TENANCY = '/api/pm/tenancy';
export const PM_RECEIPT = '/api/pm/receipt';
export const PM_REVERSE = '/api/pm/reverse';
export const PM_DASHBOARD = '/api/pm/dashboard';
export const PM_ONBOARDING = '/api/pm/onboarding';
export const PM_RENT_BOOK = '/api/pm/rent-book';
export const PM_RECEIPTS = '/api/pm/receipts';
export const PM_PAYMENTS = '/api/pm/payments';
export const PM_BANK_IMPORT = '/api/pm/bank-import';
export const PM_BANK_IMPORT_CONFIRM = '/api/pm/bank-import/confirm';
export const PM_BANK_TRANSACTION = '/api/pm/bank-transaction';
export const PM_CREDITOR_BILLS = '/api/pm/creditor-bills';
export const PM_CREDITOR_BILL = '/api/pm/creditor-bill';
export const PM_DISBURSE = '/api/pm/disburse';
export const PM_DISBURSE_RUN = '/api/pm/disburse-run';
export const PM_STATEMENTS = '/api/pm/statements';
export const PM_STATEMENT = '/api/pm/statement';
export const PM_EOFY = '/api/pm/eofy';
export const PM_BOND = '/api/pm/bond';
export const PM_BONDS = '/api/pm/bonds';
export const PM_RECONCILIATION = '/api/pm/reconciliation';
export const PM_AUDIT_EXPORT = '/api/pm/audit-export';
export const PM_REPORT = '/api/pm/report';
export const PM_WORK_ORDERS = '/api/pm/work-orders';
export const PM_WORK_ORDER = '/api/pm/work-order';
export const PM_INSPECTIONS = '/api/pm/inspections';
export const PM_INSPECTION = '/api/pm/inspection';
export const PM_DUE_SUMMARY = '/api/pm/due-summary';
export const PM_PORTAL_LINK = '/api/pm/portal-link';
export const PM_ARREARS_REMIND = '/api/pm/arrears-remind';

// External portal accounts (owner/tenant/vendor logins)
export const PORTAL_ADMIN_INVITE = '/api/portal-admin/invite';
export const PORTAL_ADMIN_USERS = '/api/portal-admin/users';
export const PORTAL_ADMIN_RESEND = '/api/portal-admin/resend';
export const PORTAL_ADMIN_DISABLE = '/api/portal-admin/disable';
export const PORTAL_ADMIN_ELIGIBLE = '/api/portal-admin/eligible';
export const PORTAL_ADMIN_GRANT_CONTACT = '/api/portal-admin/grant-contact';
export const PORTAL_ADMIN_GRANT = '/api/portal-admin/grant';
// Notes URLs
export const CREATE_NOTE = '/api/note';
export const GET_NOTES_BY_CONTACT_ID = '/api/notes'; // The contactId will be appended dynamically
// Newest notes for many contacts at once (contact CSV export) — POST, body carries the ids.
export const LOOKUP_NOTES = '/api/notes/lookup';
export const UPDATE_NOTE = '/api/note'; // The noteId will be appended dynamically
export const DELETE_NOTE = '/api/note';
export const CONTACT_EMAIL_ACTIVITY_API_URL = "/api/contact-email-activity";
export const EMAIL_DROPBOX_API_URL = "/api/email-dropbox";
export const GET_CONTACT_LISTINGS = "/api/contact";
export const POST_ASSOCIATE_LISTING = "/api/contact/associate-listing";
export const GET_LISTING_CONTACTS = "/api/contact/listing";
export const GET_LISTING_CONTACTS_NEW = "/api/listing";